import $ from 'jquery';
window.addEventListener('px-ready',function(){
    $('[js-open-mobile-menu]').click(function(){
        $('#swup').addClass('mobile-menu-open');
        return false;
    })
    $('[js-close-mobile-menu]').click(function(){
        $('#swup').removeClass('mobile-menu-open');
        $('.px-mobile-menu .menu-item-has-children').removeClass('is-active');
        $('.px-mobile-menu').removeClass('is-in-sub');
        return false;
    })
    $('.px-mobile-menu .menu-item-has-children>a').click(function(){
        $(this).parent().addClass('is-active');
        $('.px-mobile-menu').addClass('is-in-sub');
        return false;
    })
    $('.px-mobile-menu .menu-item-has-children .sub-menu').each(function(){
        $(this).prepend('<li><a href="#" class="return"></a></li>');
    })
    $('.px-mobile-menu .menu-item-has-children .sub-menu').on('click',' .return',function(){
        $('.px-mobile-menu .menu-item-has-children').removeClass('is-active');
        $('.px-mobile-menu').removeClass('is-in-sub');
        return false;
    })
})